import { AbstractSearchCriteria } from './abstract-search-criteria';

export class RoomFacilitySearchCriteria extends AbstractSearchCriteria {
    id: number;
    name: string = '';
}
